export const MY_TIMESHEET_ENTRIES_LOAD_REQUESTED =
    'MY_TIMESHEET_ENTRIES_LOAD_REQUESTED';
export const MY_TIMESHEET_ENTRIES_LOAD_SUCCEEDED =
    'MY_TIMESHEET_ENTRIES_LOAD_SUCCEEDED';
export const MY_TIMESHEET_ENTRIES_LOAD_FAILED =
    'MY_TIMESHEET_ENTRIES_LOAD_FAILED';
export const MY_TIMESHEET_ENTRIES_LOAD_CANCELED =
    'MY_TIMESHEET_ENTRIES_LOAD_CANCELED';
export const MY_TIMESHEET_ENTRIES_SAVE_REQUESTED =
    'MY_TIMESHEET_ENTRIES_SAVE_REQUESTED';
export const MY_TIMESHEET_ENTRIES_SAVE_SUCCEEDED =
    'MY_TIMESHEET_ENTRIES_SAVE_SUCCEEDED';
export const MY_TIMESHEET_ENTRIES_SAVE_FAILED =
    'MY_TIMESHEET_ENTRIES_SAVE_FAILED';
export const MY_TIMESHEET_ENTRY_ADD = 'MY_TIMESHEET_ENTRY_ADD';
export const MY_TIMESHEET_ENTRY_UPDATE = 'MY_TIMESHEET_ENTRY_UPDATE';
export const MY_TIMESHEET_ENTRY_REMOVE = 'MY_TIMESHEET_ENTRY_REMOVE';
export const MY_TIMESHEET_ENTRIES_SET_READ_ONLY =
    'MY_TIMESHEET_ENTRIES_SET_READ_ONLY';
export const MY_TIMESHEET_ENTRIES_SET = 'MY_TIMESHEET_ENTRIES_SET';
export const MY_TIMESHEET_ENTRIES_MERGE = 'MY_TIMESHEET_ENTRIES_MERGE';
export const MY_TIMESHEET_ENTRIES_DELETE = 'MY_TIMESHEET_ENTRIES_DELETE';
export const MY_TIMESHEET_ENTRY_BULK_DELETE = 'MY_TIMESHEET_ENTRY_BULK_DELETE';

export const myTimesheetEntryFields = [
    'date',
    'earnings',
    'effectiveRate',
    'endTime',
    'entityId',
    'entityName',
    'hasEditedPaidBreak',
    'hasEditedUnpaidBreak',
    'lastReviewIsApproved',
    'lastReviewedAt',
    'paidBreakMinutes',
    'rate',
    'startTime',
    'totalPaidMinutes',
    'units',
    'unpaidBreakMinutes',
    'uuid',
    'workTypeId',
    'workTypeIsPieceRate',
    'workTypeName',
    'timesheetId',
    'createdByUserId',
    'groupId'
];
